import { Typography } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Divider from "@material-ui/core/Divider";
import Icon from "@material-ui/core/Icon";
import Paper from "@material-ui/core/Paper";
import { withStyles } from "@material-ui/core/styles";
import { lighten } from "@material-ui/core/styles/colorManipulator";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import Toolbar from "@material-ui/core/Toolbar";
import Tooltip from "@material-ui/core/Tooltip";
import classNames from "classnames";
import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";

import { mapActionsToProps as agentAction } from "../../redux/agent";
import { mapActionsToProps as channelAction } from "../../redux/cloudPBX/channel";
import { mapActionsToProps } from "../../redux/contactCenter/agentStatus";

function desc(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function stableSort(array, cmp) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = cmp(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

function getSorting(order, orderBy) {
  return order === "desc"
    ? (a, b) => desc(a, b, orderBy)
    : (a, b) => -desc(a, b, orderBy);
}

const rows = [
  { id: "code", numeric: false, disablePadding: true, label: "Mã ĐTV" },
  { id: "fullname", numeric: true, disablePadding: false, label: "Họ tên" },
  {
    id: "extension.name",
    numeric: true,
    disablePadding: false,
    label: "Điện thoại",
  },
  { id: "group.name", numeric: true, disablePadding: false, label: "Nhóm" },
  {
    id: "user.fullname",
    numeric: true,
    disablePadding: false,
    label: "Người quản lý",
  },
];

class MonitorHead extends React.Component {
  createSortHandler = (property) => (event) => {
    this.props.onRequestSort(event, property);
  };

  render() {
    const { order, orderBy } = this.props;

    return (
      <TableHead>
        <TableRow>
          {rows.map(
            (row) => (
              <TableCell
                key={row.id}
                padding={"default"}
                sortDirection={orderBy === row.id ? order : false}>
                <Tooltip
                  title="Sort"
                  placement={row.numeric ? "bottom-end" : "bottom-start"}
                  enterDelay={300}>
                  <TableSortLabel
                    active={orderBy === row.id}
                    direction={order}
                    onClick={this.createSortHandler(row.id)}>
                    {row.label}
                  </TableSortLabel>
                </Tooltip>
              </TableCell>
            ),
            this
          )}
        </TableRow>
      </TableHead>
    );
  }
}

MonitorHead.propTypes = {
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.string.isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

const toolbarStyles = (theme) => ({
  root: {
    paddingRight: theme.spacing.unit,
  },
  highlight:
    theme.palette.type === "light"
      ? {
          color: theme.palette.secondary.main,
          backgroundColor: lighten(theme.palette.secondary.light, 0.85),
        }
      : {
          color: theme.palette.text.primary,
          backgroundColor: theme.palette.secondary.dark,
        },
  spacer: {
    flex: "1 1 100%",
  },
  actions: {
    color: theme.palette.text.secondary,
  },
  title: {
    display: "flex",
  },
  button: {
    marginRight: 10,
  },
});

let MonitorToolbar = (props) => {
  const { numSelected, classes, listStatus } = props;
  return (
    <Toolbar
      className={classNames(classes.root, {
        [classes.highlight]: numSelected > 0,
      })}>
      <div className={classes.title}>
        {listStatus
          ? listStatus.map((item, key) => {
              return (
                <Button
                  variant="contained"
                  size="small"
                  className={classes.button}
                  style={{ backgroundColor: `${item.color}`, color: "#fff" }}
                  key={key}>
                  <Icon
                    className={classNames(classes.leftIcon, classes.iconSmall)}>
                    {item.icon}
                  </Icon>
                  {item.name}
                </Button>
              );
            })
          : null}
      </div>
    </Toolbar>
  );
};

MonitorToolbar.propTypes = {
  classes: PropTypes.object.isRequired,
  listStatus: PropTypes.array,
};

MonitorToolbar.defaultProps = {
  listStatus: [],
};

MonitorToolbar = withStyles(toolbarStyles)(MonitorToolbar);

const styles = (theme) => ({
  root: {
    width: "100%",
    marginTop: theme.spacing.unit * 3,
  },
  table: {
    minWidth: 1020,
  },
  tableWrapper: {
    overflowX: "auto",
  },
  titleTable: {
    padding: "15px 20px",
    fontSize: 20,
  },
});

class Monitor extends React.Component {
  state = {
    order: "asc",
    orderBy: "calories",
    selected: [],
    data: [],
    page: 0,
    rowsPerPage: 5,
  };

  async componentDidMount() {
    // await this.props.getListAgentStatus(null, null, null, null,
    //     {
    //         include: [
    //             { "relation": "status" },
    //         ]
    //     })
    // await this.props.getListAgent(null, null, null, null, {
    //     include: [
    //         { "relation": "status" },
    //         { "relation": "group", "scope": { "fields": { "id": true, "name": true } } }
    //     ]
    // })
    // await this.props.getListChannel()
    this.interval = setInterval(() => {
      return (
        this.props.getListChannel(),
        this.props.getListAgent(null, null, null, null, {
          include: [
            { relation: "status" },
            { relation: "group", scope: { fields: { id: true, name: true } } },
          ],
        }),
        this.props.countListAgentStatus(),
        this.props.getStatusAgent(),
        this.initItem()
      );
    }, 3000);
    // this.initItem()
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }
  initItem = () => {
    const { agentStatus } = this.props;
    if (agentStatus) {
      this.props.getActiveCall(agentStatus.extension.id);
    }
  };

  handleRequestSort = (event, property) => {
    const orderBy = property;
    let order = "desc";

    if (this.state.orderBy === property && this.state.order === "desc") {
      order = "asc";
    }

    this.setState({ order, orderBy });
  };

  handleSelectAllClick = (event) => {
    if (event.target.checked) {
      this.setState((state) => ({ selected: state.data.map((n) => n.id) }));
      return;
    }
    this.setState({ selected: [] });
  };

  handleClick = (event, id) => {
    const { selected } = this.state;
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }

    this.setState({ selected: newSelected });
  };

  handleChangePage = (event, page) => {
    this.setState({ page });
  };

  handleChangeRowsPerPage = (event) => {
    this.setState({ rowsPerPage: event.target.value });
  };

  isSelected = (id) => this.state.selected.indexOf(id) !== -1;

  render() {
    const { classes, listStatus, listActiveCall, listAgents, coutStatus } =
      this.props;
    const { data, order, orderBy, selected, rowsPerPage, page } = this.state;
    const emptyRows =
      rowsPerPage - Math.min(rowsPerPage, data.length - page * rowsPerPage);
    const listStatusResult =
      typeof listStatus === "object"
        ? Object.keys(listStatus).map((key) => listStatus[key])
        : listStatus;
    const listAgentsResult =
      typeof listAgents === "object"
        ? Object.keys(listAgents).map((key) => listAgents[key])
        : listAgents;
    return (
      <React.Fragment>
        <Paper className={classes.root}>
          <MonitorToolbar listStatus={listStatusResult} />
          <Divider />
          <div className={classes.tableWrapper}>
            <Table className={classes.table} aria-labelledby="tableTitle">
              <MonitorHead
                order={order}
                orderBy={orderBy}
                onRequestSort={this.handleRequestSort}
                rowCount={data.length}
              />
              <TableBody>
                {stableSort(listAgentsResult, getSorting(order, orderBy))
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((n) => {
                    return (
                      <TableRow
                        hover
                        key={n.id}
                        style={{
                          backgroundColor: `${n.status ? n.status.color : ""}`,
                        }}>
                        <TableCell padding="default">{n.code}</TableCell>
                        <TableCell padding="default">{n.fullname}</TableCell>
                        <TableCell padding="default">
                          {n.extension.name}
                        </TableCell>
                        <TableCell padding="default">{n.group.name}</TableCell>
                        <TableCell padding="default">
                          {n.user.fullname}
                        </TableCell>
                      </TableRow>
                    );
                  })}
              </TableBody>
            </Table>
          </div>
          {/* <TablePagination
                        rowsPerPageOptions={[5, 10, 25]}
                        component="div"
                        count={coutStatus.count}
                        rowsPerPage={rowsPerPage}
                        page={filters.pageSize === 20 ? filters.page / 20 : (filters.pageSize === 40 ? filters.page / 40 : (filters.pageSize === 60 ? filters.page / 60 : (filters.pageSize === 80 ? filters.page / 80 : filters.page / 100)))}
                        backIconButtonProps={{
                            'aria-label': 'Previous Page',
                        }}
                        nextIconButtonProps={{
                            'aria-label': 'Next Page',
                        }}
                        onChangePage={this.handleChangePage}
                        onChangeRowsPerPage={this.handleChangeRowsPerPage}
                    /> */}
        </Paper>
        <Paper style={{ marginTop: 10 }}>
          <Typography className={classes.titleTable}>Cuộc gọi vào</Typography>
          <Table className={classes.table}>
            <TableHead>
              <TableRow>
                <TableCell>Số điện thoại khách hàng</TableCell>
                <TableCell>Số điện thoại nhận</TableCell>
                <TableCell>Máy lẻ</TableCell>
                <TableCell>Trạng thái</TableCell>
                <TableCell>Thời lượng</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                {listActiveCall
                  ? listActiveCall.map((item, key) => {
                      if (item.type == "inbound")
                        return (
                          <React.Fragment key={key}>
                            <TableCell>{item.from}</TableCell>
                            <TableCell>{item.to}</TableCell>
                            <TableCell>{item.extension.name}</TableCell>
                            <TableCell>{item.status}</TableCell>
                            <TableCell>{item.duration}</TableCell>
                          </React.Fragment>
                        );
                    })
                  : null}
              </TableRow>
            </TableBody>
          </Table>
        </Paper>
        <Paper style={{ marginTop: 10 }}>
          <Typography className={classes.titleTable}>Cuộc gọi ra</Typography>
          <Table className={classes.table}>
            <TableHead>
              <TableRow>
                <TableCell>Chiến dịch</TableCell>
                <TableCell>Số điện thoại gọi</TableCell>
                <TableCell>Số điện thoại khách hàng</TableCell>
                <TableCell>Máy lẻ</TableCell>
                <TableCell>Trạng thái</TableCell>
                <TableCell>Thời lượng</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                {listActiveCall
                  ? listActiveCall.map((item, key) => {
                      if (item.type == "Outbound")
                        return (
                          <React.Fragment key={key}>
                            <TableCell>
                              {item.extension ? item.extension.name : ""}
                            </TableCell>
                            <TableCell>{item.from}</TableCell>
                            <TableCell>{item.to}</TableCell>
                            <TableCell>{item.extension.name}</TableCell>
                            <TableCell>{item.status}</TableCell>
                            <TableCell>{item.duration}</TableCell>
                          </React.Fragment>
                        );
                    })
                  : null}
              </TableRow>
            </TableBody>
          </Table>
        </Paper>
      </React.Fragment>
    );
  }
}

Monitor.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  listStatus: state.agentStatus.agentStatus,
  coutStatus: state.agentStatus.count,
  listActiveCall: state.channel.activeCall,
  listAgents: state.agent.agents,
  agentStatus: state.agent.status,
});

Monitor = connect(mapStateToProps, mapActionsToProps)(Monitor);
const Channel = connect(null, channelAction)(Monitor);
const Agent = connect(null, agentAction)(Channel);

export default withStyles(styles)(Agent);
